<template>
  <contact :contactId="contactId" :key="'contact-view-' + componentKey"></contact>
</template>

<script>
import { mapState } from "vuex";
import Contact from "../components/Contact.vue";

export default {
  components: {
    Contact
  },
  data() {
    return {
      loading: false,
      componentKey: 1,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      windowWidth: (state) => state.windowWidth,
      workSelected: (state) => state.workSelected
    }),
    userPermission() {
      return this.$store.getters["employments/getPermByWork"](
        this.workSelected
      );
    },
  },
  methods: {
  },
  created() {
    this.contactId = this.$route.params.id;
    this.$Progress.finish();
  },
  mounted() {
  },
  destroyed() {
  },
  watch: {
    '$route.params.id': {
      handler: function(id) {
        this.contactId = this.$route.params.id;
        this.componentKey++;
        this.$Progress.finish();
      },
      deep: true,
      immediate: true
    }
  },
};
</script>